import React, { useState, useContext, useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import LatestNews from "../Dashboard/LatestNews";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchEventsRequest } from "../../../store/features/actions/eventsActions";
import { useUser } from "../../../context/UserContext";
import { AccountListContext } from "../../../context/AccountListContext";
import { getCompanyCodesByName } from "../../../services/accIqService";
import { useCompetitorContext } from "../../../context/CompetitorContext";
import axios from "axios";
import { getTaggedKsCompanies } from "../../../services/commonService";

function EventsWrappersGiq(props) {
  const [competitorResponse, setCompetitorResponse] = useState([]);
  const { competitorInfo } = useCompetitorContext();
  const taggedKsCompanies = getTaggedKsCompanies(competitorInfo);
  const companies_from_ks = useMemo(() => taggedKsCompanies, [competitorInfo]);

  //   const { allAccounts } = useContext(AccountListContext);
  const { user } = useUser();
  //   const { account_info } = useSelector((state) => state?.accountsReducer);
  const { currentPage, perPage, sortField, sortOrder, filter } = props;
  const dispatch = useDispatch();
  const pathName = useLocation().pathname;
  const isDashboard = pathName === "/dashboard";

  const { clientName, competitorName } = useParams();

  useEffect(() => {
    setCompetitorResponse([]);
  }, []);

  useEffect(() => {
    const getCompanyCodes = async () => {
      try {
        const companies = [clientName, competitorName];
        // const companies = ["ibm"];
        // const client_response = await getCompanyCodesByName([clientName]);
        // setClientResponse(client_response?.data?.data);
        let competitor_response = {};
        if (competitorName === "Johnson & Johnson MedTech") {
          competitor_response = await getCompanyCodesByName([
            "Johnson & Johnson",
          ]);
        } else {
          competitor_response = await getCompanyCodesByName([competitorName]);
        }
        setCompetitorResponse(competitor_response?.data?.data);
        // console.log("Response:", response);
      } catch (error) {
        console.error("Error posting data:", error);
      }
    };

    getCompanyCodes();
  }, [clientName, competitorName]);

  //   const all_company_names = useMemo(
  //     () => allAccounts?.map((item) => item?.name),
  //     [allAccounts]
  //   );

  //   const client_company = useMemo(() => {
  //     return user?.client_profile_company_name
  //       ? [user.client_profile_company_name]
  //       : [];
  //   }, [user]);

  //   const all_companies = useMemo(
  //     () => [...all_company_names, ...client_company],
  //     [all_company_names, client_company]
  //   );

  // useEffect(() => {
  //   const fetchEvents = (params) => {
  //     console.log("SENT PARAMS: " + JSON.stringify(params));
  //     dispatch(fetchEventsRequest(params));
  //   };

  //   // const client_code = account_info?.db_details["client_code"];
  //   // const client_name = account_info?.db_details["client_name"];
  //   // const account_code = account_info?.db_details["account_code"];
  //   // const account_name = account_info?.db_details["account_name"];

  //   if (competitorResponse) {
  //     //   const client_code = clientResponse?.[0];
  //     //   const client_name = clientName;
  //     const account_code = competitorResponse?.[0];
  //     const account_name = competitorName;
  //     console.log("COMP INFO IS: " + JSON.stringify(competitorInfo));
  //     const companies_from_ks = competitorInfo?.ks_companies ?? [];
  //     const params = {
  //       // client_name,
  //       // client_code,
  //       account_name,
  //       account_code,
  //       regions: "",
  //       types: "",
  //       page: currentPage,
  //       limit: perPage,
  //       sort_by: sortField,
  //       sort_order: sortOrder,
  //       companies: companies_from_ks,
  //       ...filter,
  //     };

  //     fetchEvents(params);
  //   }
  // }, [
  //   competitorResponse,
  //   currentPage,
  //   perPage,
  //   sortField,
  //   sortOrder,
  //   filter,
  //   // account_info,
  //   // all_companies,
  //   // isDashboard,
  //   user,
  //   competitorName,
  //   dispatch,
  // ]);

  useEffect(() => {
    const fetchEvents = (params) => {
      dispatch(fetchEventsRequest(params));
    };

    if (Array.isArray(competitorResponse) && Array.isArray(companies_from_ks)) {
      const account_code = competitorResponse[0];
      const account_name = competitorName;
      const { companies, ...restFilter } = filter;
      const params = {
        account_name,
        account_code,
        regions: "",
        types: "",
        page: currentPage,
        limit: perPage,
        sort_by: sortField,
        sort_order: sortOrder,
        companies: companies_from_ks,
        ...restFilter,
      };

      fetchEvents(params);
    }
  }, [
    competitorResponse,
    competitorInfo,
    currentPage,
    perPage,
    sortField,
    sortOrder,
    filter,
    competitorName,
    dispatch,
  ]);

  return <LatestNews />;
}

export default EventsWrappersGiq;
